export default (options) => {
  const msgbox = document.createElement('div');
  msgbox.className = 'msgbox';
  const predefined = ['error', 'info', 'question', 'success', 'warning', 'yn'];
  const fa6 = ['solid', 'regular', 'light', 'thin'];
  let title;
  let buttons = options.buttons ? options.buttons : [];
  const type = options.type ? options.type.toLowerCase() : 'custom';

  if (options.icon && typeof options.icon === 'object') {
    if (fa6.indexOf(options.icon.type) >= 0) {
      options.icon.type = `fa-${options.icon.type}`;
    }

    title = options.title ? options.title : dic.labels.notice;
    const icon = document.createElement('i');
    icon.className = options.icon.type + ' ' + options.icon.name;
    msgbox.className = 'msgbox msgbox-grid';

    if(options.class){
      msgbox.className += ' ' + options.class;
    }

    msgbox.append(icon);
  } else if (predefined.includes(type)) {
    const icon = document.createElement('i');

    switch (type) {
      case 'error':
        if (buttons.length === 0) {
          buttons.push({ text: options.bt1 || dic.labels.ok, click: (options.click && typeof options.click === 'function') ? (options.click) : (null) });
        }

        title = options.title ? options.title : dic.labels.error;
        icon.className = 'msgbox-icon msgbox-icon-error fa-solid fa-circle-xmark';
        break;
      case 'info':
        if (buttons.length === 0) {
          buttons.push({ text: options.bt1 || dic.labels.ok, data:{button:'enter'}, click: (options.click && typeof options.click === 'function') ? (options.click) : (null) });
        }

        title = options.title ? options.title : dic.labels.info;
        icon.className = 'msgbox-icon msgbox-icon-info fa-solid fa-circle-info';
        break;
      case 'question':
        if (buttons.length === 0) {
          buttons.push({ text: options.bt1 || dic.labels.cancel, data:{button:'esc'}, color: 'red', click: (options.click && typeof options.nclick === 'function') ? (options.nclick) : (null) });
          buttons.push({ text: options.bt2 || dic.labels.ok, data:{button:'enter'}, color: 'green', click: (options.click && typeof options.click === 'function') ? (options.click) : (null) });
        }

        title = options.title ? options.title : dic.labels.question;
        icon.className = 'msgbox-icon msgbox-icon-question fa-solid fa-circle-question';
        break;
      case 'success':
        if (buttons.length === 0) {
          buttons.push({ text: options.bt1 || dic.labels.ok, data:{button:'enter'}, color: 'green', click: (options.click && typeof options.click === 'function') ? (options.click) : (null) });
        }

        title = options.title ? options.title : dic.labels.success;
        icon.className = 'msgbox-icon msgbox-icon-success fa-solid fa-circle-check';
        break;
      case 'warning':
        if (buttons.length === 0) {
          buttons.push({ text: options.bt1 || dic.labels.ok, data:{button:'enter'}, click: (options.click && typeof options.click === 'function') ? (options.click) : (null) });
        }

        title = options.title ? options.title : dic.labels.warning;
        icon.className = 'msgbox-icon msgbox-icon-warning fa-solid fa-triangle-exclamation';
        break;
      case 'yn':
        buttons = [
          { text: options.bt1 || dic.labels.no, data:{button:'esc'}, color: 'red', click: (options.nclick && typeof options.nclick === 'function') ? (options.nclick) : (null) },
          { text: options.bt2 || dic.labels.yes, data:{button:'enter'}, color: 'green', click: (options.click && typeof options.click === 'function') ? (options.click) : (null) }
        ];

        title = options.title ? options.title : dic.labels.warning;
        icon.className = 'msgbox-icon msgbox-icon-question fa-solid fa-circle-question';
        break;
    }

    msgbox.className = 'msgbox msgbox-grid';
    msgbox.append(icon);
  } else {
    if (buttons.length === 0) {
      buttons.push({ text: dic.labels.ok, data:{button:'enter'}, click: (options.click && typeof options.click === 'function') ? (options.click) : (null) });
    }
    title = options.title ? options.title : dic.labels.notice;
  }

  const message = document.createElement('div');
  if (typeof options.message === 'object') {
    options.message.parent = message;
    create(options.message);
  } else {
    message.innerHTML = options.message;
  }

  if (options.class) {
    const classes = Array.isArray(options.class)
      ? options.class
      : String(options.class).split(/\s+/);
    classes.filter(Boolean).forEach(cls => msgbox.classList.add(cls));
  }

  const close = options.close !== false;

  const handleOpen = () => {
    if (typeof options.onOpen === 'function') {
      options.onOpen();
    }

    const dialog = msgbox.closest('.dialog');
    const focusable = dialog?.querySelectorAll('.dialog-buttons button, .dialog-top-buttons button, button.dialog-close');
    if (focusable && focusable.length > 0) {
      focusable[focusable.length - 1].focus();
    }
  };

  msgbox.append(message);
  msgbox.dialog({
    scope: options.scope,
    modal: true,
    effect: 'zoom',
    title: title,
    autoOpen: true,
    kill: true,
    close:close,
    buttons: buttons,
    onOpen:handleOpen,
    onClose:options.onClose
  });
}
